import { useEffect, useRef, useState } from 'react'

export const useCountDown = (stop = false, UnixValue: number) => {
    const futureTime = UnixValue * 1000

    const [time, setTime] = useState(futureTime - Date.now())

    const intervalRef = useRef<NodeJS.Timer | null>(null)

    useEffect(() => {
        // Don`t remove lines above
        // if (intervalRef.current) {
        //     clearInterval(intervalRef.current)
        //     intervalRef.current = null
        //     return
        // }

        const interval = (intervalRef.current = setInterval(() => {
            setTime(futureTime - Date.now())
        }, 1000))

        return () => clearInterval(interval)
    }, [stop, futureTime])

    return getReturnValues(time, UnixValue)
}

const getReturnValues = (countDown: number, UnixValue: number) => {
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

    return UnixValue * 1000 < Date.now()
        ? [0, 0, 0, 0]
        : [days, hours, minutes, seconds]
}
